export default "__VITE_ASSET__DmI9mNLz__"